import React from "react";
import { FONT, T } from "./tokens";
import { Chevron, DiagramShell, Layer, rowChips } from "./primitives";

const BdfArchitecture = ({ title }) => {
  const W = 840;
  const x = 28;
  const w = W - 56;
  const innerX = x + 16;
  const innerW = w - 32;
  const gap = 10;
  const chipH = 48;
  const layerH = 118;

  const apps = 72;
  const proto = apps + layerH + 24;
  const agent = proto + layerH + 24;
  const store = agent + layerH + 24;
  const note = store + 102 + 16;

  return (
    <DiagramShell
      uid="bdf"
      viewBox={`0 0 ${W} ${note + 64}`}
      title="BDF SOFTWARE ARCHITECTURE"
      subtitle="Four-layer decoupled stack · applications to media"
      label={title}
    >
      <Layer x={x} y={apps} w={w} h={layerH} theme={T.purple} title="APPLICATIONS">
        {rowChips(
          [
            ["KV Cache", "GPU"],
            "Virtualization",
            "NFS / MinIO",
            "K8S CSI",
          ],
          { x: innerX, y: apps + 42, w: innerW, h: chipH, gap, theme: T.purple }
        )}
      </Layer>
      <Chevron x={W / 2} y={apps + layerH + 6} />

      <Layer
        x={x}
        y={proto}
        w={w}
        h={layerH}
        theme={T.indigo}
        title="STORAGE PROTOCOLS"
      >
        {rowChips(
          ["NVMe", "vhost-user", ["NVMe-oF", "RDMA / TCP"], "iSCSI", "ublk"],
          { x: innerX, y: proto + 42, w: innerW, h: chipH, gap, theme: T.indigo }
        )}
      </Layer>
      <Chevron x={W / 2} y={proto + layerH + 6} />

      <Layer x={x} y={agent} w={w} h={layerH} theme={T.amber} title="BDF AGENT">
        {rowChips(
          ["MGT", "TELEMETRY", "HEALTH", "ALERT", ["LVOL", "PROVISION"]],
          { x: innerX, y: agent + 42, w: innerW, h: chipH, gap, theme: T.amber }
        )}
      </Layer>
      <Chevron x={W / 2} y={agent + layerH + 6} />

      <Layer
        x={x}
        y={store}
        w={w}
        h={102}
        theme={T.cyan}
        title="BDF STORAGE CORE  ·  USER-SPACE"
      >
        {rowChips(
          [
            ["Cache Tier", "Gen5/6 TLC (fast, durable)"],
            ["Base Tier", "Gen4 QLC (ultra-large capacity, cost-effective)"],
          ],
          {
            x: innerX,
            y: store + 40,
            w: innerW,
            h: 46,
            gap: 12,
            theme: T.cyan,
          }
        )}
      </Layer>

      <g>
        <rect
          x={x}
          y={note}
          width={w}
          height={44}
          rx="12"
          fill={T.amber.fill}
          stroke={T.amber.line}
          strokeWidth="1.15"
        />
        <text
          x={W / 2}
          y={note + 27}
          textAnchor="middle"
          fill={T.amber.text}
          fontSize="12"
          fontWeight="600"
          fontFamily={FONT}
        >
          KERNEL BYPASS: poll-mode reactors · zero context switch · zero interrupt · zero kernel-user copy
        </text>
      </g>
    </DiagramShell>
  );
};

export default BdfArchitecture;
